import React from 'react';
import { isString } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { Tile } from '../../styles/slide-out-menu';
import { useModalTriggerHandler } from '../../utils/hooks';

export default function MenuTile({ children, title='Lorem Ipsum', type, data, faIcon=faInfoCircle, onClick }) {
  
  const clickHandler = useModalTriggerHandler(data, type);
  
  const content = children && isString(children)? children : title;

  return(
    <Tile onClick={onClick || clickHandler} >
      <FontAwesomeIcon icon={faIcon} />
      <p>{ content }</p>
    </Tile>
  );
}